import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/locationgcc/dubai_new/end_to_end_dubai.webp";
import { Link } from "gatsby";

function Endtoenddubai() {
  return (
    <section
      className="end_to_end_dubai"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <h2>End-to-End Mobile App Development Company in Dubai</h2>
            <p>
              We design and code next-gen mobile application from scratch to
              guide businesses towards digital enablement and ROI maximization.
              Join the ranks of 100s of UAE-based companies TekRevol helped
              develop and launch build-for-experience, scalable mobile
              applications.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Start App Development
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Endtoenddubai;
